module.exports = __webpack_public_path__ + "static/media/(V)_MG_6122_-_Joias_Contenporaneas.2f6fa5da.jpg";